import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import 'core-js/es/reflect';
class AgeCalculator {
	constructor() {
		this.initEvents();
	}

	initEvents() {
		this.form = SelectorEngine.findOne('.p-age-calculator-form');
		this.inputs = document.querySelectorAll('.p-age-calculator-input');
		this.table = SelectorEngine.findOne('.p-age-calculator-table');
		this.dayInput = SelectorEngine.findOne('.p-age-calculator-day');
		this.monthInput = SelectorEngine.findOne('.p-age-calculator-month');
		this.yearInput = SelectorEngine.findOne('.p-age-calculator-year');
		this.currentYear = new Date().getFullYear().toString();
		this.currentEndDate = this.NextEndDate = 31;
		this.error = SelectorEngine.findOne('.p-age-calculator-form .js-age-calculator-input-error');
		this.errorText = this.error ? this.error.innerHTML : ''
		this.NextYear = parseInt(this.currentYear) + 1;

		this.tableData = [
			[this.currentYear, '01/01/' + this.currentYear, +this.currentEndDate + '/12/' + this.currentYear, null, null, null],
			[this.NextYear + '', '01/01/' + this.NextYear, +this.NextEndDate + '/12/' + this.NextYear, null, null, null]
		];
		this.listOfValues = [
			[3, '8 & Under', 'Red'],
			[4, '8 & Under', 'Red'],
			[5, '8 & Under', 'Red'],
			[6, '8 & Under', 'Red'],
			[7, '8 & Under', 'Red'],
			[8, '8 & Under / 9 & Under', 'Red / Orange'],
			[9, '9 & Under / 10 & Under', 'Orange / Green'],
			[10, '10 & Under / 11 & Under', 'Green / Yellow'],
			[11, '11 & Under / 12 & Under', 'Green / Yellow'],
			[12, '12 & Under', 'Yellow'],
			[13, '14 & Under', 'Yellow'],
			[14, '14 & Under', 'Yellow'],
			[15, '16 & Under', 'Yellow'],
			[16, '16 & Under', 'Yellow'],
			[17, '18 & Under', 'Yellow'],
			[18, '18 & Under', 'Yellow'],
			[19, 'Open', 'Yellow']
		];

		// Add validation on click event
		const submit = SelectorEngine.findOne('.p-age-calculator-submit');
		EventHandler.on(submit, 'click', (e) => {
			const emptyValue = this.dayInput.value == '' || this.monthInput.value == '' || this.yearInput.value == '';
			// Empty value
			if ( emptyValue ) {
				this.error.innerHTML = 'Please enter a date of birth';
				if (this.error.classList.contains('u-hidden')) {
					this.error.classList.remove('u-hidden');
					this.form.classList.add('hasError');
				}
				if ( !this.table.classList.contains('u-hidden') ) this.table.classList.add('u-hidden');
				this.dayInput.focus();
				return;
			}

			if (this.validInput()) {
				if (!this.error.classList.contains('u-hidden')) {
					this.error.classList.add('u-hidden');
					this.form.classList.remove('hasError');
				}
			} else if ( this.error.classList.contains('u-hidden') ) {
				// Not valid input & error not already visible
				if (this.error.innerHTML != this.errorText) this.error.innerHTML = this.errorText;
				this.error.classList.remove('u-hidden');
				this.form.classList.add('hasError');
				if ( !this.table.classList.contains('u-hidden') ) this.table.classList.add('u-hidden');
				this.dayInput.focus();
				return;
			} else {
				if (this.error.innerHTML != this.errorText) this.error.innerHTML = this.errorText;
				if ( !this.table.classList.contains('u-hidden') ) this.table.classList.add('u-hidden');
				this.dayInput.focus();
				return;
			}

			this.startCalculate();

		});

		EventHandler.on(this.yearInput, 'keypress', (e) => {
			if (e.keyCode === 13) {
				submit.click();
			}
		});

		// Add reset on reset button click
		const reset = SelectorEngine.findOne('.p-age-calculator-reset');
		EventHandler.on(reset, 'click', () => {
			this.inputs.forEach((e, i) => {
				e.value = '';
			});

			this.form.classList.remove('p-age-calculator-form--completed');
			this.table.classList.add('u-hidden');
			document.getElementById('age-calculator-table').innerHTML = '';
			if (!this.error.classList.contains('u-hidden')) {
				this.error.classList.add('u-hidden');
				this.form.classList.remove('hasError');
			}
		});

		this.initValidate();
	}

	initValidate() {
		this.inputs.forEach((element) => {
			EventHandler.on(element, 'input', (event) => {
				let self = event.target;
				let value = self.value.length;

				// If the length is maximum
				if (!self.classList.contains('p-age-calculator-year') && value === 2) {
					self.blur();
					setTimeout(() => {
						self.nextElementSibling.focus();
					}, 10);
				}
			});

			EventHandler.on(element, 'keydown', (event) => {
				const self = event.target,
					value = self.value.length,
					key = event.key;
				if ( event.keyCode === 13 ) return;
				if ( (event.keyCode != 8) && isFinite(key) && ( ( self.classList.contains('p-age-calculator-year') && value === 4 ) || (!self.classList.contains('p-age-calculator-year') && value === 2) ) ) {
					event.preventDefault();
					self.value = event.key;
				}
			});

			// eslint-disable-next-line complexity
			EventHandler.on(element, 'focusout', (event) => {
				const  self = event.target,
					valueL = self.value.length,
					value = parseInt(self.value),
					dayInput = parseInt(this.dayInput.value, 10),
					monthInput = parseInt(this.monthInput.value, 10);

				if (!self.classList.contains('p-age-calculator-year') && valueL === 1) {
					self.value = '0' + self.value;
				}

				if (
					(self.classList.contains('p-age-calculator-day') && (value > 31 || value === 0) ) ||
					(self.classList.contains('p-age-calculator-month') && (value > 12 || value === 0) ) ||
					(self.classList.contains('p-age-calculator-year') && ( (value >= parseInt(this.currentYear) - 2)
						|| (dayInput > 28 && monthInput == 2) || value === 0 ) )
				) {
					if (this.error.innerHTML != this.errorText) this.error.innerHTML = this.errorText;
					if ( this.error.classList.contains('u-hidden') ) {
						this.error.classList.remove('u-hidden');
						this.form.classList.add('hasError');
					}
					if ( !this.table.classList.contains('u-hidden') ) this.table.classList.add('u-hidden');
				} else if ( self.classList.contains('p-age-calculator-year') && dayInput <= 31 && monthInput<= 12 && !this.error.classList.contains('u-hidden') ) {
					this.error.classList.add('u-hidden');
					this.form.classList.remove('hasError');
				}
			});
		});

		// Accessibility Keyboard Navigation

		let inputArray1 = SelectorEngine.find('.p-age-calculator-year, .p-age-calculator-month');
		let inputArray2 = SelectorEngine.find('.p-age-calculator-day, .p-age-calculator-month');

		inputArray1.forEach( (element) => {
			EventHandler.on(element, 'keydown', (e) => {
				let keyCode = e.keyCode;
				let self = e.target;

				if ( (keyCode === 8 && self.value.length === 0) || keyCode === 37 || keyCode === 38 ) {
					self.blur();
					setTimeout(() => {
						self.previousElementSibling.focus();
					}, 10);
				}
			});
		});

		inputArray2.forEach( (element) => {
			EventHandler.on(element, 'keydown', (e) => {
				let keyCode = e.keyCode;
				let self = e.target;

				if (keyCode === 39 || keyCode === 40) {
					self.blur();
					setTimeout(() => {
						self.nextElementSibling.focus();
					}, 10);
				}
			});
		});
	}

	validInput() {
		const dayInput = parseInt(this.dayInput.value, 10),
			monthInput = parseInt(this.monthInput.value, 10),
			yearInput = parseInt(this.yearInput.value, 10);

		return dayInput > 31 || monthInput > 12 || (yearInput >= parseInt(this.currentYear) - 2) || dayInput === 0 || monthInput === 0 || yearInput === 0 || ( dayInput > 28 && monthInput == 2) ?
			false : true;
	}

	calculate_age(dob, endDate) {
		var ynew = endDate.getFullYear();
		var mnew = endDate.getMonth();
		var dnew = endDate.getDate();
		var yold = dob.getFullYear();
		var mold = dob.getMonth();
		var dold = dob.getDate();
		var diff = ynew - yold;
		if (mold > mnew) diff--;
		else {
			if (mold == mnew) {
				if (dold > dnew) diff--;
			}
		}
		return diff;
	}

	getDateObject(date) {
		let yearMonthDay = date.split('/');
		return new Date(yearMonthDay[2], yearMonthDay[1], yearMonthDay[0]);
	}

	startCalculate() {
		this.table.innerHTML = '';
		let dob =
			SelectorEngine.findOne('.p-age-calculator-day').value +
			'/' +
			SelectorEngine.findOne('.p-age-calculator-month').value +
			'/' +
			SelectorEngine.findOne('.p-age-calculator-year').value;
		let finalHtml =
			'<thead><tr><th>Year</th><th>Start Date</th><th>End Date</th><th>Tennis Age</th><th>Age Group</th><th>Ball Colour</th></tr></thead><tbody>';
		for (let i = 0; i < this.tableData.length; i++) {
			this.tableData[i][3] = this.calculate_age(this.getDateObject(dob), this.getDateObject(this.tableData[i][2]));
			let ageGroupAndBallColour = this.getAgeGroupAndBallColour(this.tableData[i][3], this.tableData[i][0]);
			this.tableData[i][4] = ageGroupAndBallColour[1];
			this.tableData[i][5] = ageGroupAndBallColour[2];
			finalHtml +=
				'<tr><td>' +
				this.tableData[i][0] +
				'</td><td>' +
				this.tableData[i][1] +
				'</td><td>' +
				this.tableData[i][2] +
				'</td><td>' +
				this.tableData[i][3] +
				'</td><td>' +
				this.tableData[i][4] +
				'</td><td>' +
				this.tableData[i][5] +
				'</td></tr>';
		}
		finalHtml += '</tbody>';
		this.form.classList.add('p-age-calculator-form--completed');
		this.table.innerHTML = finalHtml;
		this.table.classList.remove('u-hidden');
		window.scrollTo(0, this.table.offsetTop - 16);
		this.table.focus();
	}

	getAgeGroupAndBallColour(age, season) {
		if (age > 18) {
			return this.listOfValues[16];
		}
		for (let i = 0; i < this.listOfValues.length; i++) {
			if (this.listOfValues[i][0] === age) {
				if (parseInt(season) < 2020) {
					return [this.listOfValues[i][0], this.listOfValues[i][1].split(' / ')[0], this.listOfValues[i][2].split(' / ')[0]];
				}
				return this.listOfValues[i];
			}
		}
	}
}

const globalAgeCalculator = new AgeCalculator();
export default globalAgeCalculator;
